import { Feature, GeometryObject, Point } from "geojson";
import { LatLng, Layer, circleMarker } from "leaflet";

import { GeoJSON, useMap } from "react-leaflet";
import { Instance } from "mobx-state-tree";
import { StaticLayer as StaticLayerModel } from "../models/Layers";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../models/Root";
import { useEffect, useMemo, useState } from "react";

const staticLayerPane = "staticLayerPane";

interface StaticLayerProps {
  model: Instance<typeof StaticLayerModel>;
}

const StaticLayer = ({ model }: StaticLayerProps) => {
  const { visible, color, geoJson } = model;
  const map = useMap();
  useMemo(() => {
    const pane = map.getPane(staticLayerPane) || map.createPane(staticLayerPane);
    pane.style.zIndex = "598";
  }, [map]);
  const {
    layers: { setSelectedFeature },
  } = useRootStore();

  const onEachFeature = (feature: Feature<GeometryObject>, layer: Layer) => {
    layer.on({
      click: () => {
        setSelectedFeature(feature);
      },
    });
  };

  const pointToLayer = (_: Feature<Point, {}>, latlng: LatLng) => {
    return circleMarker(latlng, {});
  };

  const [visible_, setVisible] = useState(visible);

  useEffect(() => {
    setVisible(visible);
  }, [visible]);

  if (geoJson && visible_) {
    return (
      <GeoJSON
        data={geoJson}
        pane={staticLayerPane}
        style={
          color
            ? { color, className: "static-layer-feature" }
            : { className: "static-layer-feature" }
        }
        onEachFeature={onEachFeature}
        pointToLayer={pointToLayer}
      ></GeoJSON>
    );
  } else {
    return null;
  }
};

export default observer(StaticLayer);
